import { CircularProgress, Dialog } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { FunctionComponent, useCallback, useEffect, useState } from 'react';

import AttachmentUpload from '../../pages/NewWork/components/AttachmentUpload';
import { FooterButton } from '../../pages/NewWork/components/FooterButtons/styled';
import { 
    AttachmentUploadWrapper,
    DialogButtonContainer,
    DialogCloseButton, 
    DialogContent, 
    DialogDescription,
    dialogPaperProps, 
    DialogTextField,
    DialogTitle 
} from './styled';

interface FeedbackBugDialogProps {
    open: boolean;
    onClose: () => void;
    details: string;
    onDetailsChange: (details: string) => void;
    onSubmit: (attachmentIds: number[]) => void;
    isLoading?: boolean;
    title: string;
    description: string;
    placeholder?: string;
    ariaLabelId?: string;
}

const FeedbackBugDialog: FunctionComponent<FeedbackBugDialogProps> = ({
    open,
    onClose,
    details,
    onDetailsChange,
    onSubmit,
    isLoading = false,
    title,
    description,
    placeholder = 'Please describe...',
    ariaLabelId = 'feedback-dialog-title'
}) => {
    const [ attachmentIds, setAttachmentIds ] = useState<number[]>([]);
    const [ isUploading, setIsUploading ] = useState(false);

    const handleSubmit = useCallback(() => {
        onSubmit(attachmentIds);
    }, [ attachmentIds, onSubmit ]);

    // Reset attachmentIds when dialog closes
    useEffect(() => {
        if (!open) {
            setAttachmentIds([]);
        }
    }, [ open ]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby={ariaLabelId}
            aria-describedby={`${ariaLabelId}-description`}
            PaperProps={dialogPaperProps}
            maxWidth="md"
            fullWidth
        >
            <DialogCloseButton onClick={onClose}>
                <CloseIcon />
            </DialogCloseButton>
            <DialogTitle id={ariaLabelId}>{title}</DialogTitle>
            <DialogContent>
                <DialogDescription>
                    {description}
                </DialogDescription>
                <DialogTextField
                    multiline
                    rows={6}
                    variant="outlined"
                    fullWidth
                    placeholder={placeholder}
                    value={details}
                    onChange={(e) => onDetailsChange(e.target.value)}
                />
                <AttachmentUploadWrapper>
                    <AttachmentUpload
                        attachmentIds={attachmentIds}
                        setAttachmentIds={setAttachmentIds}
                        hideHeader
                        persistToStorage={false}
                        enablePaste={false}
                        showOnlyCompleted
                        onUploadingChange={setIsUploading}
                        isBug={true}
                    />
                </AttachmentUploadWrapper>
                <DialogButtonContainer>
                    <FooterButton onClick={onClose}>
                        Cancel
                    </FooterButton>
                    <FooterButton 
                        onClick={handleSubmit}
                        disabled={!details.trim() || isUploading || isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
                    </FooterButton>
                </DialogButtonContainer>
            </DialogContent>
        </Dialog>
    );
};

export default FeedbackBugDialog;

